export const FONT_NOT_FOUND_ERROR = 'font_not_found'
